<template>
  <li class="section">
    <fieldset>
      <ol class="questions">
        <li class="parents">
          <fieldset>
            <ol class="questions">
              <li>
                <fieldset>
                  <ol class="questions compact">
                    <li>
                      <label
                        id="givennames-label"
                        for="givennames"
                      >
                        <span class="label"
                          >Parent {{ parentNumber }}’s current given name(s)</span
                        >
                        <small class="hint"
                          >If not known, write 'unknown'.</small
                        >
                      </label>

                      <input
                        autocomplete="off"
                        class="titleCaseNameOnFirstBlur"
                        id="givennames"
                        type="text"
                        size="15"
                        :name="`Parent ${parentNumber} Given Names`"
                        maxlength="255"
                        role="presentation"
                        placeholder=""
                        v-model="parentDetails.givennames"
                      />
                    </li>
                    <li>
                      <label
                        id="surname-label"
                        for="surname"
                      >
                        <span class="label"
                          >Parent {{ parentNumber }}’s current family name</span
                        >
                        <small class="hint"
                          >If not known, write 'unknown'.</small
                        >
                      </label>

                      <input
                        autocomplete="off"
                        class="titleCaseNameOnFirstBlur"
                        id="surname"
                        type="text"
                        size="15"
                        :name="`Parent ${parentNumber}'s Surname`"
                        maxlength="255"
                        role="presentation"
                        v-model="parentDetails.surname"
                      />
                    </li>
                  </ol>
                </fieldset>
              </li>
              <li>
                <fieldset>
                  <legend>
                    <span class="label"
                      >Is parent {{ parentNumber }}'s' birth name the same as their
                      current name?</span
                    >
                  </legend>
                  <ul class="choices compact">
                    <li>
                      <input
                        type="radio"
                        :id="
                          `person${personNumber}Parent${parentNumber}BirthNameSameAsCurrent.yes`
                        "
                        :name="`Parent ${parentNumber} Birth Name Same as Current`"
                        value="true"
                        v-model="birthNameSameAsCurrent"
                      />
                      <label
                        :for="
                          `person${personNumber}Parent${parentNumber}BirthNameSameAsCurrent.yes`
                        "
                        >Yes</label
                      >
                    </li>
                    <li>
                      <input
                        type="radio"
                        :id="
                          `person${personNumber}Parent${parentNumber}BirthNameSameAsCurrent.no`
                        "
                        :name="
                          `Parent ${parentNumber} Birth Name Same as Current`
                        "
                        value="false"
                        v-model="birthNameSameAsCurrent"
                      />
                      <label
                        :for="
                          `person${personNumber}Parent${parentNumber}BirthNameSameAsCurrent.no`
                        "
                        >No</label
                      >
                    </li>
                  </ul>
                </fieldset>
              </li>
            </ol>
            <ol
              v-if="birthNameSameAsCurrent === 'false'"
              class="questions compact birthName"
            >
              <li>
                <label
                  id="birthGivennames-label"
                  for="birthGivennames"
                >
                  <span class="label"
                    >Parent {{ parentNumber }}’s birth given name(s)</span
                  >
                  <small class="hint">If not known, write 'unknown'.</small>
                </label>

                <input
                  autocomplete="off"
                  class="titleCaseNameOnFirstBlur"
                  id="birthGivennames"
                  type="text"
                  size="15"
                  :name="`Parent ${parentNumber}'s Birth Given Names`"
                  maxlength="255"
                  role="presentation"
                  v-model="parentDetails.birthGivenNames"
                />
              </li>
              <li>
                <label
                  id="birthSurname-label"
                  for="birthSurname"
                >
                  <span class="label"
                    >Parent {{ parentNumber }}’s birth family name</span
                  >
                  <small class="hint">If not known, write 'unknown'.</small>
                </label>

                <input
                  autocomplete="off"
                  class="titleCaseNameOnFirstBlur"
                  id="birthSurname"
                  type="text"
                  size="15"
                  :name="`Parent ${parentNumber} Birth Surname`"
                  maxlength="255"
                  role="presentation"
                  v-model="parentDetails.birthSurname"
                />
              </li>
            </ol>
          </fieldset>
        </li>
        <li>
          <label
            id="countryOfBirth-label"
            for="countryOfBirth"
          >
            <span class="label"
              >What country was parent {{ parentNumber }} born in?</span
            >
            <small class="hint">If not known, write 'unknown'.</small>
          </label>

          <input
            autocomplete="off"
            class="titleCaseOnFirstBlur"
            id="countryOfBirth"
            type="text"
            size="30"
            name="countryOfBirth"
            maxlength="255"
            role="presentation"
            v-model="parentDetails.countryOfBirth"
          />
        </li>
      </ol>
    </fieldset>
  </li>
</template>

<script>
export default {
  data() {
    return { birthNameSameAsCurrent: '' }
  },
  props: {
    parentNumber: Number,
    personNumber: String,
    value: Object,
  },
  watch: {
    birthNameSameAsCurrent(newValue, oldValue) { // eslint-disable-line no-unused-vars
      console.log(newValue, oldValue)
      if (newValue === 'true') {
        this.parentDetails.birthGivenNames = this.parentDetails.givennames
        this.parentDetails.birthSurname = this.parentDetails.surname
      } else {
        this.parentDetails.birthGivenNames = ''
        this.parentDetails.birthSurname = ''
      }
    }
  },
  computed: {
    parentDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("parentDetailsChanged", val, this.parentNumber);
      },
    },
  },
};
</script>
